window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = [".js-qty__adjust"]

window.GIFTBOX_CUSTOM_CART_REMOVE_LINK_SELECTORS= [".ajaxcart__product-name"]

window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = [".js-qty__num"]

window.GIFTBOX_DISABLE_SECTIONS_UPDATE = location.pathname !== '/cart'


// Hide qty selector manually


  let gbInterval = setInterval(() => {
    let gifts = document.querySelectorAll('.ajaxcart__product-name[href*="free"]');

    if (!gifts) return;

    gifts.forEach((gift) => {
      let container = gift?.closest(".grid__item.two-thirds");

      let qty = container?.querySelector(".js-qty__wrapper");

      qty?.querySelectorAll("*").forEach((el) => {
        el.style["pointer-events"] = "none";
        el.setAttribute('style','visibility:hidden !important');
      });

      
    });
  }, 100);

